/* eslint-disable no-console */
export function getLogger(config) {
    const isProd = process.env.APP_ENV === 'production';
    const level = String(config?.logLevel || 'info');
    const enabledForLevel = {
        debugError: level === 'debug',
        debug: level === 'debug',
        verbose: ['debug', 'verbose'].includes(level),
        info: ['debug', 'info'].includes(level),
        log: ['debug', 'info', 'log'].includes(level),
        warn: ['debug', 'info', 'log', 'warn'].includes(level),
        error: ['debug', 'info', 'log', 'warn', 'error'].includes(level),
    };

    const isPlainObject = v => v && typeof v === 'object' && !Array.isArray(v);

    // Custom safeStringify function
    const safeStringify = (obj) => {
        const seen = new WeakSet();
        return JSON.stringify(obj, (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return '[Circular]';
                }
                seen.add(value);
            }
            return value;
        });
    };

    if (process.env.VUE_ENV === 'client' || process.env.NODE_ENV === 'local' || process.env.APP_ENV === 'local') {
        const noop = () => {};

        return {
            debugError: !isProd && level === 'debug' ? console.error.bind(console) : noop,
            debug: !isProd && level === 'debug' ? console.debug.bind(console) : noop,
            info: !isProd && ['debug', 'info'].includes(level) ? console.info.bind(console) : noop,
            log: !isProd && ['debug', 'info', 'log'].includes(level) ? console.log.bind(console) : noop,
            warn: !isProd && ['debug', 'info', 'log', 'warn'].includes(level) ? console.warn.bind(console) : noop,
            error: ['debug', 'info', 'log', 'warn', 'error'].includes(level) ? console.error.bind(console) : noop,
            verbose: !isProd && ['debug', 'verbose'].includes(level) ? console.info.bind(console) : noop,
        };
    }

    // Server: structured NDJSON to stdout, with simple, predictable arg handling.
    const write = (entry) => {
        try {
            process.stdout.write(`${safeStringify(entry)}\n`);
        } catch {
            console.log(entry);
        }
    };

    const iso = () => new Date().toISOString();
    const base = { service: 'ui' };

    const make = lvl => (...args) => {
        if (!enabledForLevel[lvl]) return;

        let meta = {};
        if (args.length > 1 && isPlainObject(args[args.length - 1])) {
            meta = args.pop();
        }

        const msg = args.map((a) => {
            if (a instanceof Error) return `${a.message}${a.stack ? `\n${a.stack}` : ''}`;
            if (typeof a === 'string') return a;
            return safeStringify(a);
        }).join(' ');

        write({ ts: iso(), level: lvl, msg, ...base, ...meta });
    };

    return {
        debugError: make('debugError'),
        debug: make('debug'),
        verbose: make('verbose'),
        info: make('info'),
        log: make('log'),
        warn: make('warn'),
        error: make('error'),
    };
}

export default getLogger;
